export const PatientAppStatusColor = {
  inactive: 'gray',
  deleted: 'red',
  expired: 'rose',
  invited: 'blue',
  're-invited': 'blue',
  'not enrolled': 'gray',
  registered: 'green',
  enrolled: 'blue',
  active: 'green',
  'logged out': 'gray',
  're-enrolled': 'green-vibrant',
  paused: 'orange',
  'invitation expired': 'rose'
};
